import { isNil } from 'lodash';
import { IAxisesAndLegendsResult } from './axisesAndLegends';

export function tryPercentage(axisesAndLegendsResult: IAxisesAndLegendsResult): IAxisesAndLegendsResult {
	// implement reasoning about %

	if (isNil(axisesAndLegendsResult) || isNil(axisesAndLegendsResult.input)
		|| isNil(axisesAndLegendsResult.input.options) || isNil(axisesAndLegendsResult.input.options.config)
		|| isNil(Array.isArray(axisesAndLegendsResult.input.options.config)
			? axisesAndLegendsResult.input.options.config[0].isPercentage
			: axisesAndLegendsResult.input.options.config.isPercentage)) {
		if (Array.isArray(axisesAndLegendsResult.input.options.config))
			axisesAndLegendsResult.input.options.config[0].isPercentage = axisesAndLegendsResult.input.options.chartType === 'pie'; // true if pie, otherwise false
		else
			axisesAndLegendsResult.input.options.config.isPercentage = axisesAndLegendsResult.input.options.chartType === 'pie'; // true if pie, otherwise false
	}

	return axisesAndLegendsResult;
}
